document.addEventListener('form_submission_result', (e) => {

	let container = e.detail.initiator.querySelector('.message');
	if( !container ) return;

	container.innerHTML = e.detail.payload.message;
	container.setAttribute('data-status', e.detail.payload.status);

	let button = container.nextElementSibling;
	if( button.tagName == 'BUTTON' && e.detail.payload.no_resubmit )
		button.remove();

	console.log(e.detail);

	if( e.detail.payload.debug ){
		console.log( e.detail.payload.debug );
	}

})